import React from "react";
import PropTypes from "prop-types";
import Base from "../Base";
import { Radio } from "antd";

@autobind
/**
 *
 */
export default class RadioGroup extends Base {
  static propTypes = {
    ...Base.propTypes,
    children: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]),
  };

  /**
   *
   * @return {XML|null}
   * @protected
   */
  get _props() {
    return this.props.$omit(["addonAfter"]);
  }

  /**
   *
   * @return {XML}
   */
  get _component() {
    const { style, children } = this.props;

    return (
      <Radio.Group
        style={({ height: 32, lineHeight: "32px" }).$assign(style)}
      >
        {children}
      </Radio.Group>
    );
  }

  /**
   *
   * @return {XML}
   */
  get _suffix() {
    return (
      <span
        className="ant-input-group-addon right"
        style={{
          width: "inherit",
          border: "1px solid #d9d9d9",
          borderRadius: 4,
          lineHeight: "22px",
        }}
      >
        {this.props.addonAfter}
      </span>
    );
  }
}
